<div class="form-group">
    <label class="clr-control-label">{{ label }}</label>
    <div class="content"><ng-content></ng-content></div>
</div>
